module.exports = __webpack_public_path__ + "static/dark-logo-19-c8438999fae2ecadfd7bf59b37da430b.png";